var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useGetList, useTranslate } from 'ra-core';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Labeled } from 'react-admin';
import { useForm } from 'react-final-form';
import { CustomFieldInput } from '../../ui/CustomFieldInput';
const useSelectInputStyles = makeStyles(theme => ({
    SelectInput: {
        width: '100%',
    },
}));
const useLabelStyles = makeStyles(theme => ({
    label: {
        fontWeight: theme.typography.fontWeightBold,
        fontSize: '1.5rem',
    },
}));
export const ApplicationCustomField = props => {
    const { fields, type } = props, rest = __rest(props, ["fields", "type"]);
    const isEdit = type === 'EDIT';
    return (React.createElement(React.Fragment, null,
        isEdit && React.createElement(EditCustomFieldData, { source: "cf", fields: fields }),
        !isEdit && React.createElement(CreateCustomField, { source: "cf" })));
};
export const EditCustomFieldData = (_a) => {
    var { fields, type } = _a, rest = __rest(_a, ["fields", "type"]);
    const { ids = [], data, loaded, error } = useGetList('customFields');
    const selectInputClasses = useSelectInputStyles();
    const labelClasses = useLabelStyles();
    const translate = useTranslate();
    const form = useForm();
    if (ids.length === 0) {
        return null;
    }
    // Merging all CustomFields and application > customfields values.
    const mergedData = Object.values(data).map((item, i) => (Object.assign(Object.assign({}, item), fields.find(itmInner => itmInner.CustomFieldUuid === item.id))));
    form.change('CustomFieldsArr', Array.from(ids));
    return (React.createElement("div", null,
        React.createElement(Labeled, { id: "customField", label: "resources.applications.fields.customField", classes: labelClasses }),
        mergedData.length === 0 ? (React.createElement(Typography, null, translate('resources.applications.fields.noCustomFields'))) : (mergedData.map(item => (React.createElement(CustomFieldInput, { key: item.id, 
            // source is required to properly link the label to the input
            source: item.id, customField: item, className: selectInputClasses.SelectInput, initialValue: item.Value }))))));
};
export const CreateCustomField = () => {
    const { ids = [], data, loaded, error } = useGetList('customFields');
    const selectInputClasses = useSelectInputStyles();
    const labelClasses = useLabelStyles();
    const translate = useTranslate();
    if (error || !loaded || ids.length === 0) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement(Labeled, { id: "customField", label: "resources.applications.fields.customField", classes: labelClasses }),
        ids.length === 0 ? (React.createElement(Typography, null, translate('resources.applications.fields.noCustomFields'))) : (ids.map(id => (React.createElement(CustomFieldInput, { key: id, 
            // source is required to properly link the label to the input
            source: data[id].id, customField: data[id], className: selectInputClasses.SelectInput }))))));
};
//# sourceMappingURL=ApplicationCustomField.js.map